// Skillform brand blue. Competition surfaces use this flat color instead of the
// per-org theme gradient, since a (sponsored) competition is a Skillform
// property, not the org's — so it stays on-brand regardless of who's viewing.
export const BRAND_BLUE = '#2563eb';
